/**
 * 主题（明/暗）全局状态
 * 仅作用于新大厅。令牌定义见 src/assets/styles/theme.scss
 */

import { ref } from 'vue'

export type ThemeMode = 'dark' | 'light'

const STORAGE_KEY = 'lobby-theme'
const DEFAULT_THEME: ThemeMode = 'dark'

const theme = ref<ThemeMode>(DEFAULT_THEME)

/** 把主题写到 <html data-theme>，CSS 变量随之切换 */
function applyTheme(mode: ThemeMode) {
  // dark 是默认 :root，不写 data-theme 也行；统一写便于调试
  document.documentElement.setAttribute('data-theme', mode)
}

/** 读取持久化的主题（无则用默认）。应在 app.mount() 前调用以减少闪烁 */
export function initTheme() {
  let saved: ThemeMode | null = null
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'dark' || v === 'light') saved = v
  } catch {
    // localStorage 不可用时静默降级
  }
  theme.value = saved ?? DEFAULT_THEME
  applyTheme(theme.value)
}

/** 设置主题并持久化 */
export function setTheme(mode: ThemeMode) {
  theme.value = mode
  applyTheme(mode)
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // 忽略写入失败
  }
}

/** 在明/暗之间切换 */
export function toggleTheme() {
  setTheme(theme.value === 'dark' ? 'light' : 'dark')
}

export function useTheme() {
  return { theme, setTheme, toggleTheme, initTheme }
}
